import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

interface IConfirmationComponentProps extends WithTranslation {
    confirmationId: string;
}

const Confirmation = (props: IConfirmationComponentProps) => {
    const { t, confirmationId } = props;

    return (
        <div className="confirmation-container">
            <h2 className="confirmation-container--title header-4">{t('confirmation_title')}</h2>
            <p className="confirmation-container--paragraph body-large">
                {t('confirmation_note').addSpace()}
                <strong>{confirmationId}</strong>
            </p>
            <h2 className="confirmation-container--title header-4">
                {t('confirmation_steps_title')}
            </h2>
            <ul className="confirmation__steps-list">
                <li className="body-large">{t('confirmation_step_treatment_duration')}</li>
                <li className="body-large">{t('confirmation_step_treating_registration')}</li>
                <li className="body-large">{t('confirmation_step_additional_info')}</li>
            </ul>
        </div>
    );
};

export default withTranslation()(Confirmation);
